module.exports = __webpack_public_path__ + "static/media/video-yardnapha-issue.7641e142.png";